import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { useT } from '../utils/i18n';
export function Footer() {
  const t = useT();
  return <footer className="py-12 border-t border-white/10 transition-colors duration-300 bg-black" data-id="element-511">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-512">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-8 border-b border-white/20 pb-8" data-id="element-513">
          <div className="md:col-span-2" data-id="element-514">
            <Link to="/" className="inline-block mb-4" data-id="element-515">
              <Logo imgClassName="h-10 w-auto" invertOnLight={false} cycleEvery={3} data-id="element-516" />
            </Link>
            <p className="text-sm font-medium leading-relaxed max-w-sm text-[#ffffff]" data-id="element-517">
              {t('footer.tagline')}
            </p>
          </div>

          <div data-id="element-518">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-519">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-520">
              <li data-id="element-521">
                <a href="tel:206-619-3742" className="hover:text-white/70 transition-colors" data-id="element-522">
                  (206) 619-3742
                </a>
              </li>
              <li data-id="element-523">
                <a href="mailto:info@253gravel.com" className="hover:text-white/70 transition-colors" data-id="element-524">
                  info@253gravel.com
                </a>
              </li>
              <li data-id="element-525">Bonney Lake, WA</li>
            </ul>
          </div>

          <div data-id="element-526">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-527">
              {t('footer.hours')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-528">
              <li className="flex justify-between" data-id="element-529">
                <span data-id="element-530">{t('footer.monFri')}</span>
                <span data-id="element-531">6:00 AM – 5:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-532">
                <span data-id="element-533">{t('footer.saturday')}</span>
                <span data-id="element-534">7:00 AM – 3:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-535">
                <span data-id="element-536">{t('footer.sunday')}</span>
                <span data-id="element-537">{t('footer.closed')}</span>
              </li>
            </ul>
          </div>

          <div data-id="element-538">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-539">
              {t('footer.resources')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-540">
              <li data-id="element-541">
                <Link to="/compare" className="hover:text-white/70 transition-colors" data-id="element-542">
                  {t('nav.compareMaterials')}
                </Link>
              </li>
              <li data-id="element-543">
                <Link to="/delivery-prep" className="hover:text-white/70 transition-colors" data-id="element-544">
                  {t('footer.deliveryPrep')}
                </Link>
              </li>
              <li data-id="element-545">
                <Link to="/delivery-zones" className="hover:text-white/70 transition-colors" data-id="element-546">
                  {t('nav.deliveryZones')}
                </Link>
              </li>
              <li data-id="element-547">
                <Link to="/diy-help" className="hover:text-white/70 transition-colors" data-id="element-548">
                  {t('footer.diyGuide')}
                </Link>
              </li>
              <li data-id="element-549">
                <Link to="/help" className="hover:text-white/70 transition-colors" data-id="element-550">
                  {t('footer.materialQuiz')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center text-sm font-medium text-white/60" data-id="element-551">
          <p data-id="element-552">
            &copy; {new Date().getFullYear()} 253Gravel. {t('footer.rights')}
          </p>
          <div className="mt-4 md:mt-0 space-x-6" data-id="element-553">
            <a href="#" className="hover:text-white transition-colors" data-id="element-554">
              {t('footer.privacy')}
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-555">
              {t('footer.terms')}
            </a>
          </div>
        </div>
      </div>
    </footer>;
}